import type { IParsedProject } from "../types";

interface IMemoryPolicyAccessProps {
  isOwner: boolean;
  projects: IParsedProject[];
}

export interface IMemoryPolicyAccess {
  canRead: boolean;
  canWrite: boolean;
}

// NOTE: NSAI-6369 — who may see and edit an organization's memory exclusions,
// the list of categories memory must never store about any of its members.
//
// Shared rather than duplicated per platform, for the reason `siem-config-access`
// gives: if web and mobile drifted, one of them would render a screen whose
// request the server answers with a 403, or hide one it would have served. The
// server is always the authority — this only decides what the UI offers.
//
// Owners pass on both, exactly as the server grants them, so no tenant has to
// build a role to keep access its owner already had.
//
// "on at least one project" matches the server's organization-scoped check: a
// member's role is held per project, and holding the level in any project of
// the organization authorizes the organization-level route.
export const getMemoryPolicyAccess = ({
  isOwner,
  projects,
}: IMemoryPolicyAccessProps): IMemoryPolicyAccess => {
  if (isOwner) {
    return { canRead: true, canWrite: true };
  }

  // NOTE: Read from the server-parsed flags rather than the raw permission
  // strings: the server has already folded the ladder in there (a write holder
  // reads as canRead), so the two levels cannot drift apart between the sides.
  return {
    canRead: projects.some(
      (project) => project.permissions.canReadMemoryPolicy,
    ),
    canWrite: projects.some(
      (project) => project.permissions.canWriteMemoryPolicy,
    ),
  };
};
